var map = {
	"./Bicycles_Thumb_1.jpg": 768,
	"./Coffee_Thumb_1.jpg": 769,
	"./Handbags_Thumb_1.jpg": 770,
	"./Paper_Thumb_1.jpg": 771,
	"./Semiconductors_Thumb_1.jpg": 772,
	"./flowers_Thumb_1.jpg": 773,
	"./spices_Thumb_1.jpg": 774,
	"./whisky_thumb_1.jpg": 775
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 767;